import { SET_C1_BANNERS } from 'redux/actionTypes';

const initialState = {
	banners: [],
};

const C1BannerReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_C1_BANNERS:
			return {
				banners: action.payload,
			};

		default:
			return state;
	}
};

export default C1BannerReducer;
